import axios from '@/plugins/axios'
import { Message } from 'element-ui'

export default {
  namespaced: true,

  state: {
    label: null,
    loading: false
  },

  mutations: {
    setLoading(state, payload) {
      state.loading = payload
    },
    setLabel(state, payload) {
      state.label = payload
    }
  },

  actions: {
    async readLabel({ commit }) {
      await axios.label.get('myprofile').then(r => {
        commit('setLabel', r.data.data[0].label)
      })
    },
    updateDescription({}, description) {
      axios.label
        .post('myprofile/description', {
          description: description
        })
        .then(() => {})
    },
    updateSocial({}, social) {
      axios.label
        .post('myprofile/social', {
          social: social
        })
        .then(() => {})
    },
    sendMessage({ commit }, message) {
      commit('setLoading', true)
      axios.label
        .post('myprofile/message', {
          text: message.text,
          subject: message.subject
        })
        .then(() => {
          commit('setLoading', false)
          Message({
            type: 'success',
            message: `Message sent successfully`
          })
        })
        .catch(() => {
          commit('setLoading', false)
        })
    }
  }
}
